import axios from "axios";
import store from "@/store";

import { Toast } from "vant";

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
const instance = axios.create({
  timeout: 30000
});
instance.interceptors.request.use(config => {
  if (store.state.token) {
    config.headers["Authorization"] = "ErpApi" + store.state.token;
  }
  return config;
});
instance.interceptors.response.use(response => {
  const res = response.data;
  if (res.code === 200 && res.logiccode === 200) {
    return res.data;
  } else if (res.Code === 200) {
    return res.Result.Data;
  } else {
    Toast.fail(res.logicmsg || res.msg);
    throw Error(res.logicmsg || res.msg);
  }
});
export default instance;
